import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "input-wrapper d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_select = _resolveComponent("v-select");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.assigned_worker_catch_yn`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.assignedWorkerCatchYnComputed,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.assignedWorkerCatchYnComputed) = $event)),
                    name: "radio-catch-yn",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.sort_by_code`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.sortByCodeComputed,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.sortByCodeComputed) = $event)),
                    items: _ctx.sortByCodeOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto"
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.kilometer_product_all_yn`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.kilometerProductAllYnComputed,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.kilometerProductAllYnComputed) = $event)),
                    name: "radio1",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.kilometer_product_range`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.minimumKilometerProductComputed,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.minimumKilometerProductComputed) = $event)),
                        items: _ctx.minKilometerProductOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        filled: _ctx.kilometerProductAllYnComputed,
                        disabled: _ctx.kilometerProductAllYnComputed,
                        error: _ctx.isNotValidKilometerProductError,
                        onKeyup: _cache[4] || (_cache[4] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.handleBlurMinimumKilometerProductTypeField(_ctx.formData.hubConfiguration.minimumKilometerProduct)))
                    }, null, 8 /* PROPS */, ["modelValue", "items", "filled", "disabled", "error"]),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mx-2" }, [
                        _createElementVNode("span", null, "~")
                    ], -1 /* CACHED */)),
                    _createVNode(_component_v_autocomplete, {
                        focused: "",
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.kilometerProductComputed,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.kilometerProductComputed) = $event)),
                        items: _ctx.maxKilometerProductOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        filled: _ctx.kilometerProductAllYnComputed,
                        disabled: _ctx.kilometerProductAllYnComputed,
                        error: _ctx.isNotValidKilometerProductError,
                        onKeyup: _cache[7] || (_cache[7] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.handleBlurKilometerProductTypeField(_ctx.formData.hubConfiguration.kilometerProduct)))
                    }, null, 8 /* PROPS */, ["modelValue", "items", "filled", "disabled", "error"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_one_click_baecha_yn`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.workerOneClickBaechaYnComputed,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.workerOneClickBaechaYnComputed) = $event)),
                    items: _ctx.workerOneClickBaechaYnOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[10] || (_cache[10] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.handleBlurWorkerOneClickBaechaYnTypeField(_ctx.formData.workerOneClickBaechaYn)))
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.share_call_color_type`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.shareCallColorTypeComputed,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.shareCallColorTypeComputed) = $event)),
                    items: _ctx.shareCallColorTypeOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[13] || (_cache[13] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.handleBlurShareCallColorTypeField(_ctx.formData.hubConfiguration.shareCallColorType)))
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.assigned_worker_lock_time`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.assignedWorkerLockTimeComputed,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.assignedWorkerLockTimeComputed) = $event)),
                    items: _ctx.assignedWorkerLockTimeOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[16] || (_cache[16] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.handleBlurAssignedWorkerLockTimeTypeField(_ctx.formData.hubConfiguration.assignedWorkerLockTime)))
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.order_show_time`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.orderShowTimeComputed,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.orderShowTimeComputed) = $event)),
                    items: _ctx.orderShowTimeOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[19] || (_cache[19] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[20] || (_cache[20] = ($event) => (_ctx.handleBlurOrderShowTimeTypeField(_ctx.formData.hubConfiguration.orderShowTime)))
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_double_click_prevention`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isDoubleClickPreventionComputed,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.isDoubleClickPreventionComputed) = $event)),
                    name: "radio-double-click",
                    density: "compact",
                    inline: "",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applyOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_assigned_worker_catch_hidden`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isAssignedWorkerCatchHiddenComputed,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.isAssignedWorkerCatchHiddenComputed) = $event)),
                    name: "radio-catch-hidden",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_allocated_after_cancel`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isAllocatedAfterCancelComputed,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.isAllocatedAfterCancelComputed) = $event)),
                    name: "radio2",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
